export function getBoundingClientRect(node) {
  return node.current.getBoundingClientRect();
}
